import { render } from "./InfraSummary.vue?vue&type=template&id=86a0b6aa&scoped=true"
import script from "./InfraSummary.vue?vue&type=script&lang=js"
export * from "./InfraSummary.vue?vue&type=script&lang=js"

import "./InfraSummary.vue?vue&type=style&index=0&id=86a0b6aa&lang=scss&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a0b6aa"]])

export default __exports__